import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agreeToAffiliateTerms } from '@/lib/api/affiliate-links/api';
import { stanNotify } from '@/lib';
import { QUERY_KEYS } from '@/lib/constants';

export function useCompleteAffiliateSetup() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (linkId: number) => agreeToAffiliateTerms(linkId),
        onSuccess: () => {
            stanNotify({
                type: 'success',
                title: 'Setup Complete',
                text: 'Your affiliate link is now active!',
                duration: 3000,
            });
            // Refresh affiliate links
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.MY_AFFILIATE_LINKS] });
        },
        onError: (error: any) => {
            const errorMessage = error?.response?.data?.message || 'Failed to complete setup. Please try again.';
            stanNotify({
                type: 'error',
                title: 'Setup Failed',
                text: errorMessage,
                duration: 3000,
            });
        },
    });
}
